import React, { useState, useEffect, useRef } from 'react';
import Header, { HeaderType } from '@/components/Layout/Header/Header';
import Footer from '@/components/Layout/Footer/Footer';
import apart from '@/assets/apart.jpg';
import pent from '@/assets/pent.jpg';
import villa from '@/assets/villa.jpg';
import MapIcon from '@mui/icons-material/Map';
import resi from '@/assets/resi.jpg';
import profile from '@/assets/man-new.jpg';
import building from '@/assets/backWal.png';
import './newLanding.css';
import { ContentLayout } from '@/components/Layout';
import { SearchTabs } from './SearchTabs';
import Slider from 'react-slick';
import { Dialog, Link } from '@/components/Elements';
import { Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import DOMPurify from 'dompurify';
import { useNotificationStore } from '@/stores/notifications';
import { axios, axios2 } from '@/lib/axios';
import NewListingLoader from '@/components/Elements/Loader/NewListingLoader';
import './custom.css';
import logo1 from '@/assets/logo1.png';
import nbanner from '@/assets/n-banner.png';
import logo2 from '@/assets/logo2.png';
import logo3 from '@/assets/logo3.png';
import logo4 from '@/assets/logo4.png';
import about from '@/assets/about-img.jpg';
import prop from '@/assets/pro-project.png';
import pros from '@/assets/pro-s-1.png';
import serv from '@/assets/services.png';
import ander from '@/assets/anderson.png';
import KeyboardBackspaceRoundedIcon from '@mui/icons-material/KeyboardBackspaceRounded';
import EastRoundedIcon from '@mui/icons-material/EastRounded';
import star from '@/assets/star.png';
import why from '@/assets/why-img.png';
import w1 from '@/assets/w1.png';
import w2 from '@/assets/w2.png';
import w3 from '@/assets/w3.png';
import mloc from '@/assets/m-location.png';
import wl from '@/assets/w-lady.png';
import wc from '@/assets/w-call.png';
import wangle from '@/assets/w-angle-img.png';
import hw1 from '@/assets/hw1.png';
import hw2 from '@/assets/hw2.png';
import hw3 from '@/assets/hw3.png';
import hw4 from '@/assets/hw4.png';
import tafter from '@/assets/tafter.png';
import bbefore from '@/assets/bbefore.png';
import searchIcon from '@/assets/searchicon.png';
import bookmark from '@/assets/bookmarkPink.png';
import PropertySaleRentList from '@/features/admin/components/PropertySaleRentList';
import { useCountryList, useLandingPage, useTopCountryList } from '@/api/landing/landingPage';
import robert from '@/assets/pexels-babix-33345009.jpg';
import { useNewLandingListing } from '@/api/landing/newLandingListing';
import marlo from '@/assets/pexels-anthonyshkraba-production-8278885.jpg';
import karlo from '@/assets/pexels-mikhail-nilov-9304680.jpg';
import { trimThirty, trimSixty, formatPrice } from '@/utils/format';
import { Checkbox, FormControlLabel, Pagination } from '@mui/material';
import GoogleMapReact from 'google-map-react';
import storage from '@/utils/storage';
import { ArrowDownIcon, ArrowRightCircleIcon } from '@heroicons/react/24/outline';

export const formatAmount = (price) => {
  // Convert the price to a string and add commas
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const stateFromHTML = require('draft-js-import-html').stateFromHTML;

export const NewHomePage = () => {
  const AnyReactComponent = ({ lat, lng, text }: { lat: any; lng: any; text: any }) => (
    <div>{text}</div>
  );
  const getDisplayPropertyType = (propertyType?: string) =>
    propertyType === 'HouseRent' ? 'FindTenant' : propertyType ?? '';
  const [loading, setLoading] = useState(false);

  const [listing, setListing] = useState<any>([]);
  const [fullApiRes, setFullApiRes] = useState<any>();
  const [isOpen, setIsOpen] = useState(false);
  const { user } = useAuth();
  const [shareLink, setShareLink] = useState('');
  const navigate = useNavigate();
  const [apply, setApply] = useState({});
  const [activeCategory, setActiveCategory] = useState('All');
  const [type, setType] = useState('');
  const [subType, setSubType] = useState('');
  const [country, setCountry] = useState('');
  const [filterData, setFilterData] = useState(false);
  const frontendUrl = process.env.REACT_APP_FRONTEND_URL as string;
  const [lat, setLat] = useState('');
  const [lng, setLng] = useState('');
  const [min, setMin] = useState('');
  const [max, setMax] = useState('');
  const [subscribe, setSubscribe] = useState('');
  const [disableSlider, setDisableSlider] = useState(false);
  const [selectedTab, setSelectedTab] = useState(false);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [priceSort, setPriceSort] = useState<string>('');
  const [dateSort, setDateSort] = useState<string>('');
  const { data: topCountry } = useTopCountryList();
  const localAmount = storage.getAmount();
  const [bathrooms, setBathrooms] = useState<number>();
  const [bedrooms, setBedrooms] = useState<number>();
  const [date, setDate] = useState<Date | null>(null);
  const localSymbol = storage.getSymbol();
  const [name, setName] = useState('');
  const [image, setImage] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [save, setSave] = useState(false);
  const [filterDataa, setFilterDataa] = useState({
    country: '',
    min_price: '',
    max_price: '',
  });
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const listingSectionRef = useRef<HTMLDivElement | null>(null);

  const { data, isLoading, refetch, isFetching } = useNewLandingListing({
    type: type,
    filter_data: true,
    search_data: '',
    bathrooms,
    bedrooms,
    date,
    dateSort,
    priceSort,
    sub_category: subType,
    latitude: lat,
    longitude: lng,
    subscription_tyre: subscribe,
    ...filterDataa,
    countries: selectedCountries.join(','),
    page: currentPage,
  });
  console.log(data, 'page_dat')

  useEffect(() => {
    setType(apply.category);
    setSubType(apply.propertyType);
    setLat(apply.latitude);
    setLng(apply.longitude);
    setMin(apply.min_price);
    setMax(apply.max_price);
    setSubscribe(apply.subscriptionType);
    setDisableSlider(apply.disableSlider ?? false);
    setFilterData(apply?.filter);
  }, [apply]);

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
    setSubType('');
    if (category === 'All') {
      setType('');
      setFilterData(false);
    } else {
      setType(category);
      setFilterData(true);
    }
  };

  const handleSubCategoryClick = (category) => {
    setActiveCategory(category);
    setType('');
    if (category === 'All') {
      setSubType('');
      setFilterData(false);
    } else {
      setSubType(category);
      setFilterData(true);
    }
  };

  const handleExplorePropertyProjects = () => {
    handleCategoryClick('PropertyProject');
    listingSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const handlePaginationChange = (_event: React.ChangeEvent<unknown>, page: number) => {
    setCurrentPage(page);
    listingSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  useEffect(() => {
    setListing(data?.data);
    console.log(data);
    setFullApiRes(data);
    // setCurrentPage(1);
  }, [data, isLoading]);

  useEffect(() => {
    refetch();
  }, [type, filterData, apply, subType, currentPage]);

  const slidersettings = {
    dots: true,
    infinite: true,
    // speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    autoplay: true,
    // autoplaySpeed: 500,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const settings = {
    dots: true,
    lazyLoad: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay: true,
    // autoplaySpeed: 5000,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },

      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const filters = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 9,
    slidesToScroll: 1,
    // autoplay: true,
    // autoplaySpeed: 5000,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const openDialog = (event, type, id) => {
    event.stopPropagation();
    const url = navigateToDetailPage(type, id);
    setShareLink(`${frontendUrl + url}`);
    setIsOpen(true);
  };

  const closeDialog = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    refetch();
  }, []);

  const renderHTML = (html) => {
    return { __html: DOMPurify.sanitize(html) };
  };

  const navigateToDetailPage = (type, id) => {
    const routes = {
      BusinessSale: `/sale-detail/${id}?type=BusinessSale`,
      SaleProperty: `/property-for-sale-detail/${id}?type=SaleProperty`,
      RentProperty: `/property-for-rent-detail/${id}?type=RentProperty`,
      HouseRent: `/housing-detail/${id}?type=HouseRent`,
      InvestmentProject: `/investment-detail/${id}?type=InvestmentProject`,
      InvestmentCompany: `/company-detail/${id}?type=InvestmentCompany`,
      PropertyProject: `/property-detail/${id}?type=PropertyProject`,
      CompanySeekingEquity: `/company-seeking-equity/${id}?type=CompanySeeking`,
      PropertyDevelopers: `/house-investment-details/${id}?type=PropertyDevelopers`,
    };

    return routes[type] || `/`;
  };

  const handleNavigation = (type, id) => {
    const url = navigateToDetailPage(type, id);
    navigate(url);
  };

  const handleFavorite = async (event, type, id, isFavourite) => {
    event.stopPropagation();

    if (!user) {
      useNotificationStore.getState().addNotification({
        title: 'Login',
        type: 'info',
        message: 'Need to Login first!',
      });
      navigate('/auth/login');
      return;
    }

    const updatedListing = listing.map((item) =>
      item.id === id ? { ...item, is_favourite: !isFavourite } : item
    );
    setListing(updatedListing);

    const apiEndpoints = {
      BusinessSale: 'favourite-unfavourite-bussiness-sale',
      SaleProperty: 'favourite-unfavourite-sale-property',
      RentProperty: 'favourite-unfavourite-rent-property',
      HouseRent: 'favourite-unfavourite-house-rent',
      InvestmentProject: 'favourite-unfavourite-invest-project',
      InvestmentCompany: 'favourite-unfavourite-invest-company',
      PropertyProject: 'favourite-unfavourite-property-project',
      companySeeking: 'favourite-unfavourite-companySeekingEquity',
      property_developers: 'favourite-unfavourite-property-developers',
    };

    const payloadKeys = {
      BusinessSale: 'business_id',
      SaleProperty: 'sale_id',
      RentProperty: 'rent_id',
      HouseRent: 'house_rent_id',
      InvestmentProject: 'invest_id',
      InvestmentCompany: 'invest_id',
      PropertyProject: 'property_project_id',
      companySeeking: 'company_seeking_id',
      property_developers: 'developer_id',
    };

    const apiUrl = `/panel-api/${apiEndpoints[type]}`;
    const payloadKey = payloadKeys[type];

    try {
      const response = await axios2.post(apiUrl, {
        [payloadKey]: id,
        status_action: !isFavourite,
      });

      useNotificationStore.getState().addNotification({
        title: `${!isFavourite ? 'Added Favorite' : 'Removed Favorite'}`,
        type: 'success',
        message: `Successfully ${!isFavourite ? 'added to' : 'removed from'} favorites`,
      });
    } catch (error) {
      console.error('Failed to update favorite status:', error);
      setListing(
        listing.map((item) => (item.id === id ? { ...item, is_favourite: isFavourite } : item))
      );
      useNotificationStore.getState().addNotification({
        title: 'Error',
        type: 'error',
        message: 'Failed to update favorite status. Please try again.',
      });
    }
  };

  const handleBedroomChange = (value) => {
    setBedrooms(value);
  };
  const handleBathroomChange = (value) => {
    setBathrooms(value);
  };

  const copyLinkToClipboard = () => {
    navigator.clipboard
      .writeText(shareLink)
      .then(() => {
        useNotificationStore.getState().addNotification({
          title: 'Copied!',
          type: 'success',
          message: 'Link copied to clipboard.',
        });
      })
      .catch((err) => {
        console.error('Failed to copy link:', err);
      });
  };

  const PHONE_NUMBER_DISPLAY = '920 851 8585';
  const PHONE_NUMBER_TEL = '9208518585';

  const isProbablyPhone = () => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
    return (
      window.matchMedia('(hover: none) and (pointer: coarse)').matches ||
      window.matchMedia('(max-width: 767px)').matches
    );
  };

  const handlePhoneNumberClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    if (isProbablyPhone()) {
      window.location.href = `tel:${PHONE_NUMBER_TEL}`;
      return;
    }

    try {
      if (!navigator?.clipboard?.writeText) throw new Error('Clipboard API not available');
      await navigator.clipboard.writeText(PHONE_NUMBER_DISPLAY);
      useNotificationStore.getState().addNotification({
        title: 'Copied!',
        type: 'success',
        message: 'Phone number copied to clipboard.',
      });
    } catch (err) {
      console.error('Failed to copy phone number:', err);
      useNotificationStore.getState().addNotification({
        title: 'Error',
        type: 'error',
        message: 'Could not copy phone number. Please copy it manually.',
      });
    }
  };

  const [activeIndex, setActiveIndex] = useState(0);

  const handleNext = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % data?.category_data.length);
  };

  const handleCheckboxChange = (event) => {
    const { checked, value } = event.target;

    setSelectedCountries((prevSelectedCountries) => {
      if (checked) {
        // If checked, add to the selectedCountries array
        return [...prevSelectedCountries, value];
      } else {
        // If unchecked, remove from the selectedCountries array
        return prevSelectedCountries.filter((country) => country !== value);
      }
    });
  };

  const handlePrev = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === 0 ? data?.category_data.length - 1 : prevIndex - 1
    );
  };

  useEffect(() => {
    if (save === true && listing?.length > 0) {
      // handleSearchApi(dataToSave);
    }
  }, [save]);

  useEffect(() => {
    const url = new URL(window.location.href);

    const paymentSuccess = url.searchParams.get('paymentpalsuccess');

    if (paymentSuccess === 'true') {
      useNotificationStore.getState().addNotification({
        title: 'Success',
        type: 'success',
        message: 'Payment Completed successfully!',
      });
    }
  }, []);

  const itemsPerPage = 8;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentListings = listing?.slice(indexOfFirstItem, indexOfLastItem);
  console.log(listing);
  const totalPages = Math.ceil((listing?.length || 0) / itemsPerPage);
  // const totalPages = Math.max(1, Math.ceil(listing?.length / itemsPerPage));

  const [center, setCenter] = useState({ lat: 0, lng: 0 });

  useEffect(() => {
    setLoading(true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setCenter({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
          setLoading(false);
        },
        (error) => {
          console.error('Error getting location:', error);
          setLoading(false);
        }
      );
    } else {
      console.error('Geolocation is not supported by this browser.');
      setLoading(false);
    }
  }, []);

  return (
    <>
      <div className="header"></div>

      <ContentLayout title="New Landing">
        <div className="landing-aphe-heaer">
          {' '}
          <Header type={HeaderType.LANDING} />{' '}
        </div>
        <div className="search-sec">
          <SearchTabs
            filterData={filterDataa}
            setFilterData={setFilterDataa}
            refetch={refetch}
            setApply={setApply}
            save={save}
            setSave={setSave}
          />
        </div>
        <div className="landing-section-tabs space-tb" ref={listingSectionRef}>
          <div className="container">
            <div className="row">
              <div className={`col-3 animations ${sidebarOpen ? 'block' : 'hidden'}`}>
                <div className="flex justify-between items-center">
                  <Button onClick={() => navigate('/map-list')} className="map-btn">
                    <MapIcon /> Show on Google
                  </Button>
                  <Button className="colapse-btn" onClick={() => setSidebarOpen((prev) => !prev)}>
                    <KeyboardBackspaceRoundedIcon />
                  </Button>
                </div>
                <div className=" pt-3 filter-box">
                  <h4 className="search-heading mb-1">Area</h4>
                  <ul className="ps-2 area-list">
                    {topCountry?.map((item: any, index: number) => {
                      return (
                        <li>
                          <FormControlLabel
                            key={index}
                            control={
                              <Checkbox value={item?.country} onChange={handleCheckboxChange} />
                            }
                            label={`${item?.country}`}
                          />
                        </li>
                      );
                    })}
                  </ul>
                  <div className="form-group row">
                    <label htmlFor="exampleFormControlInput1 col-12" className="form-label">
                      Bedroom
                    </label>
                    <div
                      className="btn-group flex-wrap col-12"
                      role="group"
                      aria-label="Bedroom options"
                    >
                      <button
                        type="button"
                        className={`btn btn-outline ${bedrooms === null ? 'btn-primary' : 'btn-outline-primary'
                          }`}
                        onClick={() => handleBedroomChange(null)}
                      >
                        All
                      </button>
                      <button
                        type="button"
                        className={`btn btn-outline ${bedrooms === 1 ? 'btn-primary' : 'btn-outline-primary'
                          }`}
                        onClick={() => handleBedroomChange(1)}
                      >
                        1+
                      </button>
                      <button
                        type="button"
                        className={`btn btn-outline ${bedrooms === 2 ? 'btn-primary' : 'btn-outline-primary'
                          }`}
                        onClick={() => handleBedroomChange(2)}
                      >
                        2+
                      </button>
                      <button
                        type="button"
                        className={`btn btn-outline ${bedrooms === 3 ? 'btn-primary' : 'btn-outline-primary'
                          }`}
                        onClick={() => handleBedroomChange(3)}
                      >
                        3+
                      </button>
                      <button
                        type="button"
                        className={`btn btn-outline ${bedrooms === 4 ? 'btn-primary' : 'btn-outline-primary'
                          }`}
                        onClick={() => handleBedroomChange('4')}
                      >
                        4+
                      </button>
                      <button
                        type="button"
                        className={`btn btn-outline ${bedrooms === 5 ? 'btn-primary' : 'btn-outline-primary'
                          }`}
                        onClick={() => handleBedroomChange(5)}
                      >
                        5+
                      </button>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="form-label" htmlFor="exampleFormControlInput1">
                      Bathroom
                    </label>
                    <div className="btn-group col-12" role="group" aria-label="Bathroom options">
                      <button
                        type="button"
                        className={`btn btn-outline ${bathrooms === 1 ? 'btn-primary' : 'btn-outline-primary'
                          }`}
                        onClick={() => handleBathroomChange(1)}
                      >
                        1+
                      </button>
                      <button
                        type="button"
                        className={`btn btn-outline ${bathrooms === 2 ? 'btn-primary' : 'btn-outline-primary'
                          }`}
                        onClick={() => handleBathroomChange(2)}
                      >
                        2+
                      </button>
                      <button
                        type="button"
                        className={`btn btn-outline ${bathrooms === 3 ? 'btn-primary' : 'btn-outline-primary'
                          }`}
                        onClick={() => handleBathroomChange(3)}
                      >
                        3+
                      </button>
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="exampleFormControlInput1" className="form-label ">
                      Date
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="exampleFormControlInput1"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                      // value={bathrooms}
                      // onChange={(e) => setBathrooms(e.target.value)}
                      placeholder="enter date"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="exampleFormControlSelect1" className="form-label">
                      Sort By Price
                    </label>
                    <select
                      className="form-control"
                      id="exampleFormControlSelect1"
                      value={priceSort}
                      onChange={(e) => setPriceSort(e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="asc">Ascending</option>
                      <option value="desc">Descending</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="exampleFormControlSelect1" className="form-label">
                      Sort By Date
                    </label>
                    <select
                      className="form-control"
                      id="exampleFormControlSelect1"
                      value={dateSort}
                      onChange={(e) => setDateSort(e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="asc">Ascending</option>
                      <option value="desc">Descending</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className={`animation pro-box relative ${sidebarOpen ? 'col-9' : 'col-12'}`}>
                <div className="flex justify-end items-start ">
                  {!sidebarOpen && (
                    <Button
                      className="colapse-btn custom-btn-side"
                      onClick={() => setSidebarOpen((prev) => !prev)}
                    >
                      <EastRoundedIcon />
                    </Button>
                  )}
                  <div className="tabs-box ">
                    {!disableSlider && (
                      <div className="main-searching-tabs gap-5 mb-5">
                        {/* <Slider {...filters}> */}
                        <div id="viewProperty" className="logo-list-wrapper d-flex py-2">
                          <div className="logo-slide">
                            <div
                              className={`cat-filter-categories text-center ${activeCategory === 'All' ? 'active' : ''
                                }`}
                            >
                              <Button
                                className="cat-link p-0 bg-transparent border-0"
                                onClick={() => handleCategoryClick('All')}
                              >
                                <img src={logo1} className="aprt-icon" alt="apartment" />
                                <h6 className="f-13 semi-bold">All</h6>
                              </Button>
                            </div>
                          </div>
                          <div className="logo-slide">
                            <div
                              className={`cat-filter-categories text-center ${activeCategory === 'RentProperty' ? 'active' : ''
                                }`}
                            >
                              <Button
                                className="cat-link p-0 bg-transparent border-0"
                                onClick={() => handleCategoryClick('RentProperty')}
                              >
                                <img src={logo2} className="aprt-icon" alt="apartment" />
                                <h6 className="f-13 semi-bold">Rent Property</h6>
                              </Button>
                            </div>
                          </div>
                          <div className="logo-slide">
                            <div
                              className={`cat-filter-categories text-center ${activeCategory === 'PropertyProject' ? 'active' : ''
                                }`}
                            >
                              <Button
                                className="cat-link p-0 bg-transparent border-0"
                                onClick={() => handleCategoryClick('PropertyProject')}
                              >
                                <img src={logo3} className="aprt-icon" alt="apartment" />
                                <h6 className="f-13 semi-bold">Property Project</h6>
                              </Button>
                            </div>
                          </div>
                          <div className="logo-slide">
                            <div
                              className={`cat-filter-categories text-center ${activeCategory === 'SaleProperty' ? 'active' : ''
                                }`}
                            >
                              <Button
                                className="cat-link p-0 bg-transparent border-0"
                                onClick={() => handleCategoryClick('SaleProperty')}
                              >
                                <img src={logo4} className="aprt-icon" alt="villa" />
                                <h6 className="f-13 semi-bold">Sale Property</h6>
                              </Button>
                            </div>
                          </div>
                          <div className="logo-slide">
                            <div
                              className={`cat-filter-categories text-center ${activeCategory === 'HouseRent' ? 'active' : ''
                                }`}
                            >
                              <Button
                                className="cat-link p-0 bg-transparent border-0"
                                onClick={() => handleCategoryClick('HouseRent')}
                              >
                                <img src={logo2} className="aprt-icon" alt="villa" />
                                <h6 className="f-13 semi-bold">FindTenant</h6>
                              </Button>
                            </div>
                          </div>
                          {/* <div className="logo-slide">
                      <div
                        className={`cat-filter-categories text-center ${
                          activeCategory === 'InvestmentCompany' ? 'active' : ''
                        }`}
                      >
                        <Button
                          className="cat-link p-0 bg-transparent border-0"
                          onClick={() => handleCategoryClick('InvestmentCompany')}
                        >
                          <img src={logo4} className="aprt-icon" alt="villa" />
                          <h6 className="f-13 semi-bold">Investment Company</h6>
                        </Button>
                      </div>
                    </div> */}
                          <div className="logo-slide">
                            <div
                              className={`cat-filter-categories text-center ${activeCategory === 'PropertyDevelopers' ? 'active' : ''
                                }`}
                            >
                              <Button
                                className="cat-link p-0 bg-transparent border-0"
                                onClick={() => handleCategoryClick('PropertyDevelopers')}
                              >
                                <img src={logo4} className="aprt-icon" alt="villa" />
                                <h6 className="f-13 semi-bold">Property Developers</h6>
                              </Button>
                            </div>
                          </div>

                          <div className="logo-slide">
                            <div
                              className={`cat-filter-categories text-center ${activeCategory === 'BusinessSale' ? 'active' : ''
                                }`}
                            >
                              <Button
                                className="cat-link p-0 bg-transparent border-0"
                                onClick={() => handleCategoryClick('BusinessSale')}
                              >
                                <img src={logo2} className="aprt-icon" alt="villa" />
                                <h6 className="f-13 semi-bold">Business For Sale</h6>
                              </Button>
                            </div>
                          </div>
                          <div className="logo-slide">
                            <div
                              className={`cat-filter-categories text-center ${activeCategory === 'CompanySeekingEquity' ? 'active' : ''
                                }`}
                            >
                              <Button
                                className="cat-link p-0 bg-transparent border-0"
                                onClick={() => handleCategoryClick('CompanySeekingEquity')}
                              >
                                <img src={logo4} className="aprt-icon" alt="villa" />
                                <h6 className="f-13 semi-bold">Company Seeking</h6>
                              </Button>
                            </div>
                          </div>
                          {/* <div className="logo-slide">
                      <div
                        className={`cat-filter-categories text-center ${
                          activeCategory === 'apartment_for_sale' ? 'active' : ''
                        }`}
                      >
                        <Button
                          className="cat-link p-0 bg-transparent border-0"
                          onClick={() => handleSubCategoryClick('apartment_for_sale')}
                        >
                          <img src={logo3} className="aprt-icon" alt="villa" />
                          <h6 className="f-13 semi-bold">Apartment for sale</h6>
                        </Button>
                      </div>
                    </div>
                    <div className="logo-slide">
                      <div
                        className={`cat-filter-categories text-center ${
                          activeCategory === 'villa_house_for_sale' ? 'active' : ''
                        }`}
                      >
                        <Button
                          className="cat-link p-0 bg-transparent border-0"
                          onClick={() => handleSubCategoryClick('villa_house_for_sale')}
                        >
                          <img src={logo2} className="aprt-icon" alt="villa" />
                          <h6 className="f-13 semi-bold">Villa/House for sale</h6>
                        </Button>
                      </div>
                    </div>
                    <div className="logo-slide">
                      <div
                        className={`cat-filter-categories text-center ${
                          activeCategory === 'townhouse' ? 'active' : ''
                        }`}
                      >
                        <Button
                          className="cat-link p-0 bg-transparent border-0"
                          onClick={() => handleSubCategoryClick('townhouse')}
                        >
                          <img src={logo4} className="aprt-icon" alt="villa" />
                          <h6 className="f-13 semi-bold">Townhouse</h6>
                        </Button>
                      </div>
                    </div>
                    <div className="logo-slide">
                      <div
                        className={`cat-filter-categories text-center ${
                          activeCategory === 'penthouse' ? 'active' : ''
                        }`}
                      >
                        <Button
                          className="cat-link p-0 bg-transparent border-0"
                          onClick={() => handleSubCategoryClick('penthouse')}
                        >
                          <img src={logo2} className="aprt-icon" alt="villa" />
                          <h6 className="f-13 semi-bold">Penthouse</h6>
                        </Button>
                      </div>
                    </div>
                    <div className="logo-slide">
                      <div
                        className={`cat-filter-categories text-center ${
                          activeCategory === 'Residential_Floor' ? 'active' : ''
                        }`}
                      >
                        <Button
                          className="cat-link p-0 bg-transparent border-0"
                          onClick={() => handleSubCategoryClick('Residential_Floor')}
                        >
                          <img src={logo3} className="aprt-icon" alt="villa" />
                          <h6 className="f-13 semi-bold">Residential Floor</h6>
                        </Button>
                      </div>
                    </div>
                    <div className="logo-slide">
                      <div
                        className={`cat-filter-categories text-center ${
                          activeCategory === 'Residential_Building' ? 'active' : ''
                        }`}
                      >
                        <Button
                          className="cat-link p-0 bg-transparent border-0"
                          onClick={() => handleSubCategoryClick('Residential_Building')}
                        >
                          <img src={logo4} className="aprt-icon" alt="villa" />
                          <h6 className="f-13 semi-bold">Residential Building</h6>
                        </Button>
                      </div>
                    </div>
                    <div className="logo-slide">
                      <div
                        className={`cat-filter-categories text-center ${
                          activeCategory === 'Villa_Compound' ? 'active' : ''
                        }`}
                      >
                        <Button
                          className="cat-link p-0 bg-transparent border-0"
                          onClick={() => handleSubCategoryClick('Villa_Compound')}
                        >
                          <img src={logo3} className="aprt-icon" alt="villa" />
                          <h6 className="f-13 semi-bold">Villa Compound</h6>
                        </Button>
                      </div>
                    </div>
                    <div className="logo-slide">
                      <div
                        className={`cat-filter-categories text-center ${
                          activeCategory === 'Commercial_for_Sale' ? 'active' : ''
                        }`}
                      >
                        <Button
                          className="cat-link p-0 bg-transparent border-0"
                          onClick={() => handleSubCategoryClick('Commercial_for_Sale')}
                        >
                          <img src={logo2} className="aprt-icon" alt="villa" />
                          <h6 className="f-13 semi-bold">Commercial for Sale</h6>
                        </Button>
                      </div>
                    </div>
                    <div className="logo-slide">
                      <div
                        className={`cat-filter-categories text-center ${
                          activeCategory === 'Land_for_Sale' ? 'active' : ''
                        }`}
                      >
                        <Button
                          className="cat-link p-0 bg-transparent border-0"
                          onClick={() => handleSubCategoryClick('Land_for_Sale')}
                        >
                          <img src={logo4} className="aprt-icon" alt="villa" />
                          <h6 className="f-13 semi-bold">Land for Sale</h6>
                        </Button>
                      </div>
                    </div>
                    <div className="logo-slide">
                      <div
                        className={`cat-filter-categories text-center ${
                          activeCategory === 'Multiple_Units_for_Sale' ? 'active' : ''
                        }`}
                      >
                        <Button
                          className="cat-link p-0 bg-transparent border-0"
                          onClick={() => handleSubCategoryClick('Multiple_Units_for_Sale')}
                        >
                          <img src={logo3} className="aprt-icon" alt="villa" />
                          <h6 className="f-13 semi-bold">Multiple Units for Sale</h6>
                        </Button>
                      </div>
                    </div> */}
                        </div>
                        {/* </Slider> */}
                      </div>
                    )}
                  </div>
                </div>

                <div className="heading-wrapper-section d-flex justify-content-between align-items-center">
                  <p className="heading">Properties</p>
                  {/* <form action="">
                <div className="search-block position-relative">
                  <span className="searchIcon position-absolute">
                    <img className="d-block w-100" src={searchIcon} alt="search" />
                  </span>
                  <input type="text" name="search" id="search" placeholder="Search" />
                </div>
              </form> */}
                </div>

                <div className="residential-tab-cards">
                  {isLoading || isFetching ? (
                    <NewListingLoader />
                  ) : (
                    <div className="row ">
                      {listing && listing?.length > 0 ? (
                        listing?.map((item: any, index: number) => {
                          const parseImageData = (data: string) => {
                            try {
                              const parsedData = eval(data);
                              if (Array.isArray(parsedData)) {
                                return parsedData;
                              }
                            } catch (e) {
                              console.log(e);
                            }
                            return [];
                          };

                          const imageData = parseImageData(
                            item?.image_data ?? item?.image ?? item?.property_image
                          );

                          return (
                            <div
                              key={index}
                              className={`animation col-12 mb-4  ${sidebarOpen ? 'col-md-4' : 'col-md-3'
                                }`}
                            >
                              <div
                                className="resi-card-box item-box deals-page h-100"
                                onClick={() => handleNavigation(item?.type, item?.id)}
                              >
                                <div className="resi-card-icon mb-1 relative">
                                  <Slider {...settings}>
                                    {imageData.length > 0 ? (
                                      imageData.map((img, idx) => (
                                        <div key={`${item.id}-${idx}`} className="res-slider-icon">
                                          <img
                                            src={img ? img : building}
                                            alt={img?.name || 'Property Image'}
                                          />
                                        </div>
                                      ))
                                    ) : (
                                      <div className="res-slider-icon">
                                        <img src={building} alt={'Property Image'} />
                                      </div>
                                    )}
                                  </Slider>
                                  <div className="resi-popup">
                                    <Button
                                      className="pop-btn bg-transparent border-0 p-0"
                                      onClick={(e) => {
                                        const first = item?.first_name ? item?.first_name : 'NA';
                                        const last = item?.last_name ? item?.last_name : 'NA';
                                        const fullname =
                                          first == 'NA' && last == 'NA' ? 'NA' : first + ' ' + last;
                                        setName(fullname);
                                        setImage(item?.customerId__profileImage);
                                        openDialog(e, item.type, item.id);
                                      }}
                                    >
                                      <span className="bg-pop">
                                        <i className="fa-solid fa-share"></i>
                                      </span>
                                    </Button>
                                  </div>
                                  <div className="resi-propname">
                                    <span className="f-14">{getDisplayPropertyType(item?.type)}</span>
                                    {item?.is_ad_featured && (
                                      <span className="f-14" style={{ marginLeft: '75px' }}>
                                        Featured
                                      </span>
                                    )}

                                    {/* {activeCategory == 'All' && (
                                  <span className="f-14">{item?.type}</span>
                                )} */}
                                  </div>
                                  <div className="wish-popup">
                                    {/* <Button
                                  className="save-btn bg-transparent border-0 p-0"
                                >
                                  <span className="bg-pop">
                                    <img src={bookmark} alt="" />
                                  </span>
                                </Button> */}

                                    <Button
                                      className="wish-btn bg-transparent border-0 p-0"
                                      onClick={(e) =>
                                        handleFavorite(e, item.type, item.id, item.is_favourite)
                                      }
                                    >
                                      <span className="bg-pop">
                                        <i
                                          className={`fa-heart ${item.is_favourite
                                            ? 'fa-solid text-danger'
                                            : 'fa-regular'
                                            }`}
                                        ></i>
                                      </span>
                                    </Button>
                                  </div>
                                </div>
                                <div className="resi-content">
                                  <p className="f-16 semi-bold mb-0 price">
                                    {localSymbol}
                                    {formatAmount(formatPrice(item?.filter_price * localAmount))}
                                  </p>
                                  <h4 className="semi-bold f-16 title">{item?.title}</h4>
                                  <p
                                    className="f-15 mb-0 location"
                                    dangerouslySetInnerHTML={renderHTML(item?.location || '')}
                                  >
                                    {/* <i className="fa-solid fa-map-location-dot"></i> */}
                                  </p>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div
                          className="col-12 d-flex align-items-center justify-content-center"
                          style={{ minHeight: '40vh' }}
                        >
                          <p className="text-center mb-0">NO DATA FOUND</p>
                        </div>
                      )}

                      {data?.property_listing?.length > 0 && (
                        <div className="home-pagination d-flex justify-content-center mt-4">
                          <Pagination
                            count={fullApiRes?.total_pages ?? 1}
                            page={currentPage}
                            onChange={handlePaginationChange}
                            variant="outlined"
                            color="primary"
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <section>
          <div className="about-us-sec">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-5">
                  <div className="about-img h-100">
                    <img src={about} className="a-img h-100" alt="about" />
                  </div>
                </div>
                <div className="col-md-7">
                  <div className="about-content">
                    <h2 className="heading-color fw-600">About Us</h2>
                    <p className="heading-color">
                      REEIPO is passionate about property and offers a unique, transparent
                      experience for all of your real estate investment needs. Check out our large
                      marketplace if you’re looking for your next property, investment, renter, or
                      business opportunity.
                      <br />
                      After all, real estate is better when it’s at your fingertips, on your time.
                      <br />
                      <br />
                      <strong> Efficient Real Estate and Investment Deals </strong>
                      <br />
                      <br />
                      REEIPO offers efficient options where the deals come to you as well as
                      do-it-yourself options. Our focus is delivering the same seamless experience
                      and helping people take their next steps intentionally.
                    </p>
                    <div className="a-view-btn mt-4">
                      <button
                        type="button"
                        className="btn btn-black black-btn-custom"
                        onClick={() => navigate('/about-us')}
                      >
                        View All
                      </button>
                    </div>
                  </div>
                  {/* <div className="row mt-5">
                    <div className="col-md-6">
                      <div className="k-user p-4 rounded-24">
                        <h4 className="">178K+</h4>
                        <p className="mb-0">
                          Lorem ipsum dolor amet, consectetur adipiscing elit. Faucibus in
                          libero.Lorem ipsum dolor amet,
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="k2-user p-4 rounded-24">
                        <h4 className="">132</h4>
                        <p className="mb-0">
                          Lorem ipsum dolor amet, consectetur adipiscing elit. Faucibus in
                          libero.Lorem ipsum dolor amet,
                        </p>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="pro-project-sec" style={{ backgroundImage: 'url(' + prop + ')' }}>
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-5">
                  <h2 className="text-white mb-4 cat-title f-40">Categories</h2>
                  <h3 className="text-white fw-500">Property projects</h3>
                  <p className="text-white fw-400">
                    Whether you're looking for a dream home, a profitable investment, or the perfect
                    business space, we offer a variety of top-tier projects to choose from. Our
                    properties are strategically located, ensuring convenience, accessibility, and
                    value for money. Browse through our portfolio and take the first step toward
                    securing a future full of potential. With expert guidance and a commitment to
                    quality, we’re here to help you find the ideal property that suits your
                    lifestyle and goals.
                  </p>
                  <div className="a-explore-btn mt-4">
                    <button type="button" className="btn btn-black black-btn-custom" onClick={handleExplorePropertyProjects}>
                      Explore
                    </button>
                  </div>
                </div>
                <div className="col-md-7">
                  <div className="prop-slider mt-3">
                    <div className="slider1">
                      <div className="inner ">
                        {/* Slider */}
                        <Slider {...slidersettings}>
                          {data?.category_data?.map((item: any, index: number) => {
                            return (
                              <div key={index} className="w-75">
                                <div className="card-flex d-flex gap-2 justify-content-between align-items-center">
                                  <div className="prop-img">
                                    <img src={item?.image} alt="pay1" />
                                    <div className="prop-text">
                                      <h6 className="mb-0 head-limit-line text-white">
                                        {item?.title}
                                      </h6>
                                      <p
                                        className="mb-0 text-white text-limit-lines fw-400"
                                        dangerouslySetInnerHTML={{
                                          __html: trimThirty(item?.description),
                                        }}
                                      >
                                        {/* {articleContent && <div dangerouslySetInnerHTML={{ __html: articleContent }} />} */}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </Slider>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="services-us-sec mb-5 mt-4">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="service-img">
                    <img src={serv} className="a-img h-50" alt="about" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="services-content text-end">
                    <h2 className="heading-color fw-600">Services</h2>
                    <p className="heading-color mb-4">
                      Our services are designed to simplify the property buying, selling, and
                      renting process. Whether you’re looking to sell your property, purchase a new
                      home, or rent a space, we provide expert guidance every step of the way. We
                      help buyers find the perfect property, assist sellers in getting the best
                      value for their assets, and offer rental solutions to those seeking a home or
                      investment property. Our platform also connects property owners with reliable
                      tenants, ensuring a smooth and hassle-free renting experience for both
                      parties.{' '}
                    </p>
                    <div className="a-view-btn">
                      <button onClick={() => navigate('how_It_work?page=how_It_work')} type="button" className="btn btn-black black-btn-custom">
                        View All
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="number-box-sec mt-4">
                <div className="row-flex d-flex flex-lg-nowrap flex-wrap gap-3">
                  <div className="n-one p-3">
                    <h2 className="text-white">01</h2>
                    <h4 className="text-black">Buy Property</h4>
                    <p className="text-black">
                      Find your perfect home or investment property with expert help and guidance.{' '}
                    </p>
                  </div>
                  <div className="n-two p-3">
                    <h2 className="text-white">02</h2>
                    <h4 className="text-black">Sell Property</h4>
                    <p className="text-black">
                      Maximize your property's value and connect with potential buyers effortlessly.{' '}
                    </p>
                  </div>
                  <div className="n-three p-3">
                    <h2 className="text-white">03</h2>
                    <h4 className="text-black">Rent a Property</h4>
                    <p className="text-black">
                      Discover rental options that fit your needs, whether for home or business.{' '}
                    </p>
                  </div>
                  <div className="n-four p-3">
                    <h2 className="text-white">04</h2>
                    <h4 className="text-black">Rent Out Property</h4>
                    <p className="text-black">
                      Connect with reliable tenants and ensure a smooth renting experience.{' '}
                    </p>
                  </div>
                  <div className="n-five p-3">
                    <h2 className="text-white">05</h2>
                    <h4 className="text-black">Invest in Property</h4>
                    <p className="text-black">
                      Get expert advice on the best property investment opportunities for your
                      future.{' '}
                    </p>
                  </div>
                </div>
              </div>
              <div className="need-help py-5 my-5">
                <div className="row">
                  <div className="col-md-10 mx-auto">
                    <div className="row">
                      <div className="col-md-6">
                        <h3 className="heading-color">Need help? Talk to our expert.</h3>
                        <p className="mb-0">
                          Talk to our experts or Browse through more properties.
                        </p>
                      </div>
                      <div className="col-md-6">
                        <div className="can-call-btn">
                          <div className="cont-btn d-flex gap-3">
                            <div className="ca-btn">
                              <button type="button" className="btn btn-primary" onClick={() => navigate('/contact-us')}>
                                Contact Us{' '}
                                <span>
                                  <i className="fa-solid fa-arrow-up text-black ps-2"></i>
                                </span>
                              </button>
                            </div>

                            <div className="nu-btn a-view-btn">
                              <button
                                type="button"
                                className="btn btn-black bg-black text-white"
                                onClick={handlePhoneNumberClick}
                                aria-label={`Call or copy ${PHONE_NUMBER_DISPLAY}`}
                                title="Mobile: call • Desktop: copy number"
                              >
                                <span>
                                  <i className="fa-solid fa-phone text-white pe-2"></i>{' '}
                                </span>
                                {PHONE_NUMBER_DISPLAY}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="how-it-works-sec py-5">
            <div className="container">
              <div className="row">
                <div className="col-md-12 text-center">
                  <h2 className="heading-color">How it works</h2>
                  <p className="w-75 mx-auto">
                    {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit. Faucibus in libero
                    risus mper habitant arcu eget. Et integer facilisi eget. Lorem ipsum dolor.
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Faucibus in libero
                    risus mper habitant arcu eget. Et integer facilisi eget. Lorem ipsum dolor. */}
                    {/* <div dangerouslySetInnerHTML={{ __html: data?.how_it_work?.page_content }} /> */}
                  </p>
                </div>
                <div className="works-box mt-5">
                  <div className="row gy-4">
                    {data?.how_it_works
                      ?.sort((a: any, b: any) => {
                        return parseInt(a?.step_number) - parseInt(b?.step_number);
                      })
                      .map((item: any, index: number) => {
                        return (
                          <div className="col-md-3 how-it-work-section">
                            <div className="o-box ">
                              <div className="o-img text-center">
                                <img src={item?.icon} alt="hw1" className="mx-auto prop-img" />
                                <div className="px-4 py-4">
                                  <h6 className="mb-3 text-black fw-600">{item?.title}</h6>
                                  <p dangerouslySetInnerHTML={{ __html: item?.description }}></p>
                                  <span className="n1">{item?.step_number}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}

                    {/* <div className="col-md-3">
                      <div className="o-box p-4">
                        <div className="o-img text-center">
                          <img src={hw2} alt="hw1" className="mx-auto" />
                          <h6 className="my-3 fw-600">Submit Your Property</h6>
                          <p>
                            Contact us by calling, emailing or submitting the form online and tell
                            us a little more details about your house.
                          </p>
                          <span className="n1">02</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="o-box p-4">
                        <div className="o-img text-center">
                          <img src={hw3} alt="hw1" className="mx-auto" />
                          <h6 className="my-3 fw-600">Submit Your Property</h6>
                          <p>
                            Contact us by calling, emailing or submitting the form online and tell
                            us a little more details about your house.
                          </p>
                          <span className="n1">03</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="o-box p-4">
                        <div className="o-img text-center">
                          <img src={hw4} alt="hw1" className="mx-auto" />
                          <h6 className="my-3 fw-600">Submit Your Property</h6>
                          <p>
                            Contact us by calling, emailing or submitting the form online and tell
                            us a little more details about your house.
                          </p>
                          <span className="n1">04</span>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="why-choose-us mt-5">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="why-img pe-5">
                    <img src={why} alt="why-img" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="why-text">
                    <h3 className="heading-color">Why Choose Us</h3>
                    <p className="heading-color ">
                      As the complexity of buildings to increase, the field of architecture.
                    </p>
                  </div>
                  <div className="managment-sec">
                    <div className="pro-mngmnt d-flex align-items-center gap-3 mt-5">
                      <img src={w1} alt="w1" />
                      <div className="mngmnt-text">
                        <h6>Property Management</h6>
                        <p>
                          Comprehensive property management services, handling maintenance, tenant
                          relations, and more to keep your property in top condition.
                        </p>
                      </div>
                    </div>
                    <div className=" serv pro-mngmnt d-flex align-items-center gap-3 mt-5">
                      <img src={w2} alt="w1" />
                      <div className="mngmnt-text">
                        <h6>Mortgage Services</h6>
                        <p>
                          Expert guidance in securing the best mortgage options, ensuring a smooth
                          and hassle-free property financing process.
                        </p>
                      </div>
                    </div>
                    <div className="curr pro-mngmnt d-flex align-items-center gap-3 mt-5">
                      <img src={w3} alt="w1" />
                      <div className="mngmnt-text">
                        <h6>Currency Services</h6>
                        <p>
                          Providing secure and reliable currency exchange and international
                          transaction services for your global financial needs.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluids">
              <div className="m-location mt-4">
                {loading ? (
                  <>loading.....</>
                ) : (
                  <div className="rounded-10" style={{ height: '400px', width: '100%' }}>
                    <GoogleMapReact
                      bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY }}
                      defaultCenter={{ lat: center?.lat, lng: center?.lng }}
                      defaultZoom={13}
                    >
                      <AnyReactComponent
                        lat={center?.lat}
                        lng={center?.lng}
                        text={<i className="fa-sharp fa-solid fa-location-dot googleEarth"></i>}
                      />
                    </GoogleMapReact>
                  </div>
                )}{' '}
              </div>
            </div>

            {/* 
<section className="map-contat" style={{ padding: '20px' }}>
          <div className="map-img-right bg-white rounded-20 shadow p-2">
          
          </div>
        </section> */}
          </div>
        </section>
        {/* <section>
          <div className="we-are-sec bg-im-dark">
            <div className="container">
              <div className="row pt-5">
                <div className="col-md-3 pe-0">
                  <div className="lady-img">
                    <img src={wl} alt="lady" />
                  </div>
                </div>
                <div className="col-md-9 ps-0">
                  <div className="we-heading  pt-4">
                    <h4 className="text-white">We’re Providing the Best Real Estate Services</h4>
                    <p className="text-light">
                      Make a type specimen book. It has survived not onlyfive centuries, but also
                      the leap into.
                    </p>
                  </div>
                  <div className="w-call-img">
                    <div className="w-call d-flex gap-5 align-items-center">
                      <div className="w-c-icon d-flex align-items-center">
                        <img src={wc} alt="call" />

                        <div className="w-c-text">
                          <p className="text-white mb-0 border-end pe-5">Our Hot Line:</p>
                          <p className="text-white mb-0">(888) 972-7121</p>
                        </div>
                      </div>
                      <div className=" email w-c-icon d-flex align-items-center">
                        <span className="footer-mail-icon">
                          <i className="fa-solid fa-envelope"></i>
                        </span>
                        <div className="w-c-text">
                          <p className="text-white mb-0">Mail Us:</p>
                          <p className="text-white mb-0">info@gmail.com</p>
                        </div>
                      </div>
                    </div>
                    <div className="reqest-btn a-view-btn ps-3 mt-4">
                      <button type="button" className="btn btn-black py-4" onClick={()=>navigate('/contact-us')}>
                        REQUEST A FAIR CASH OFFER TODAY
                      </button>
                    </div>
                    <div className="angle-img">
                      <img src={wangle} alt="img" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        <section>
          <div className="review-sec mt-5">
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <div className="review">
                    <h4 className="text-black">Testimonials</h4>
                    <p>See what our clients have to say about our services!</p>
                  </div>
                </div>

                <div className="review-slider mt-3">
                  <div className="slider2">
                    <div
                      id="carouselExampleAutoplaying"
                      className="carousel slide"
                      data-bs-ride="carousel"
                    >
                      <div className="carousel-inner">
                        <div className="carousel-item active">
                          <div className="d-flex gap-2">
                            <div className="box-1  p-3 mb-5 bg-body-tertiary rounded-12 shadow">
                              <div className="card-flex">
                                <h5>Great Work</h5>
                                <p className="my-3">
                                  “The service provided was exceptional. I was truly impressed with
                                  how professional and efficient the team was. They handled
                                  everything seamlessly and delivered results beyond my
                                  expectations. Highly recommend!”
                                </p>
                                <div className="star-content border-bottom pb-3">
                                  <div className="d-flex">
                                    <img src={star} alt="pay1" />
                                  </div>
                                </div>
                                <div className="anderson mt-3 d-flex gap-2 align-items-center">
                                  <img src={ander} alt="pay1" />
                                  <div className="and-text">
                                    <h6 className=" mb-0">Anderson</h6>
                                    <p className="  mb-0">22 Aug 2024</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="box-1  p-3 mb-5 bg-body-tertiary rounded-12 shadow">
                              <div className="card-flex">
                                <h5>Nice Job</h5>
                                <p className="my-3">
                                  “A fantastic experience from start to finish! The team was very
                                  communicative, and the results exceeded what I had hoped for. I
                                  couldn't be more pleased with their work!”
                                </p>
                                <div className="star-content border-bottom pb-3">
                                  <div className="d-flex">
                                    <img src={star} alt="pay1" />
                                  </div>
                                </div>
                                <div className="anderson mt-3 d-flex gap-2 align-items-center">
                                  <img src={marlo} alt="pay1" />
                                  <div className="and-text">
                                    <h6 className=" mb-0">Robert</h6>
                                    <p className="  mb-0">15 Jan 2024</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="box-1  p-3 mb-5 bg-body-tertiary rounded-12 shadow">
                              <div className="card-flex">
                                <h5>Dream Fulfilled</h5>
                                <p className="my-3">
                                  "I'm really impressed with the quality of work provided. Every
                                  step of the project was handled with great attention to detail.
                                  Would definitely work with them again!"
                                </p>
                                <div className="star-content border-bottom pb-3">
                                  <div className="d-flex">
                                    <img src={star} alt="pay1" />
                                  </div>
                                </div>
                                <div className="anderson mt-3 d-flex gap-2 align-items-center">
                                  <img src={karlo} alt="pay1" />
                                  <div className="and-text">
                                    <h6 className=" mb-0">Anderson</h6>
                                    <p className="  mb-0">22 Aug 2024</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="box-1  p-3 mb-5 bg-body-tertiary rounded-12 shadow">
                              <div className="card-flex">
                                <h5>“Excellent Work</h5>
                                <p className="my-3">
                                  “Excellent service and top-notch professionalism. The team was
                                  able to address all my concerns and delivered exactly what I was
                                  looking for. A job well done!”
                                </p>
                                <div className="star-content border-bottom pb-3">
                                  <div className="d-flex">
                                    <img src={star} alt="pay1" />
                                  </div>
                                </div>
                                <div className="anderson mt-3 d-flex gap-2 align-items-center">
                                  <img src={robert} alt="pay1" />
                                  <div className="and-text">
                                    <h6 className=" mb-0">Anderson</h6>
                                    <p className="  mb-0">22 Aug 2024</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <div className="carousel-item">
                          <div className="d-flex gap-2">
                            <div className="box-1  p-3 mb-5 bg-body-tertiary rounded-12 ">
                              <div className="card-flex">
                                <h5>Great Work</h5>
                                <p className="my-3">
                                  "Working with this team was an absolute pleasure. They understood
                                  our needs from the start and provided outstanding results. Their
                                  attention to detail and commitment to quality is unparalleled. I
                                  couldn’t be happier with the final outcome and the entire process.
                                  Highly recommend them for any project!"
                                </p>
                                <div className="star-content border-bottom pb-3">
                                  <div className="d-flex">
                                    <img src={star} alt="pay1" />
                                  </div>
                                </div>
                                <div className="anderson mt-3 d-flex gap-2 align-items-center">
                                  <img src={ander} alt="pay1" />
                                  <div className="and-text">
                                    <h6 className=" mb-0">Anderson</h6>
                                    <p className="  mb-0">22 Aug 2024</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="box-1  p-3 mb-5 bg-body-tertiary rounded-12">
                              <div className="card-flex">
                                <h5>Great Work</h5>
                                <p className="my-3">
                                “Excellent service and top-notch professionalism. The team was
                                  able to address all my concerns and delivered exactly what I was
                                  looking for. A job well done!”
                                </p>
                                <div className="star-content border-bottom pb-3">
                                  <div className="d-flex">
                                    <img src={star} alt="pay1" />
                                  </div>
                                </div>
                                <div className="anderson mt-3 d-flex gap-2 align-items-center">
                                  <img src={ander} alt="pay1" />
                                  <div className="and-text">
                                    <h6 className=" mb-0">Anderson</h6>
                                    <p className="  mb-0">22 Aug 2024</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="carousel-item">
                          <div className="d-flex gap-2">
                            <div className="box-1  p-3 mb-5 bg-body-tertiary rounded-12">
                              <div className="card-flex">
                                <h5>Great Work</h5>
                                <p className="my-3">
                                "Working with this team was an absolute pleasure. They understood
                                  our needs from the start and provided outstanding results. Their
                                  attention to detail and commitment to quality is unparalleled. I
                                  couldn’t be happier with the final outcome and the entire process.
                                  Highly recommend them for any project!"
                                </p>
                                <div className="star-content border-bottom pb-3">
                                  <div className="d-flex">
                                    <img src={star} alt="pay1" />
                                  </div>
                                </div>
                                <div className="anderson mt-3 d-flex gap-2 align-items-center">
                                  <img src={ander} alt="pay1" />
                                  <div className="and-text">
                                    <h6 className=" mb-0">Anderson</h6>
                                    <p className="  mb-0">22 Aug 2024</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="box-1  p-3 mb-5 bg-body-tertiary rounded-12">
                              <div className="card-flex">
                                <h5>Great Work</h5>
                                <p className="my-3">
                                “Excellent service and top-notch professionalism. The team was
                                  able to address all my concerns and delivered exactly what I was
                                  looking for. A job well done!”
                                </p>
                                <div className="star-content border-bottom pb-3">
                                  <div className="d-flex">
                                    <img src={star} alt="pay1" />
                                  </div>
                                </div>
                                <div className="anderson mt-3 d-flex gap-2 align-items-center">
                                  <img src={ander} alt="pay1" />
                                  <div className="and-text">
                                    <h6 className=" mb-0">Anderson</h6>
                                    <p className="  mb-0">22 Aug 2024</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Dialog isOpen={isOpen} onClose={closeDialog}>
          <div className="inline-block share-modal-home align-top bg-white px-4 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
            <div className="share-exp-modal">
              <div className="row">
                <div className="col-12">
                  <div className="share-experience">
                    <h5 className="f-20 mb-0 text-black">Share this experience</h5>
                    <div className="share-img-col d-flex gap-4 align-items-center my-4">
                      <img src={image ? image : profile} className="share-img-exp" />
                      <p className="f-15 mb-0">with {name}</p>
                    </div>
                    <div className="experience-shares d-flex gap-3">
                      <Button type="button" className="exp-button" onClick={copyLinkToClipboard}>
                        <i className="fa-solid fa-copy me-3"></i> Copy Link
                      </Button>
                      <Button
                        type="button"
                        className="exp-button"
                        onClick={() =>
                          window.open(`mailto:?subject=Check this out&body=${shareLink}`, '_blank')
                        }
                      >
                        <i className="fa-regular fa-envelope me-3"></i> Email
                      </Button>
                      <Button
                        type="button"
                        className="exp-button"
                        onClick={() => window.open(`sms:?body=${shareLink}`, '_blank')}
                      >
                        <i className="fa-solid fa-comment me-3"></i> Messages
                      </Button>
                      <Button
                        type="button"
                        className="exp-button"
                        onClick={() => window.open(`https://wa.me/?text=${shareLink}`, '_blank')}
                      >
                        <i className="fa-brands fa-whatsapp me-3"></i> WhatsApp
                      </Button>
                      <Button
                        type="button"
                        className="exp-button"
                        onClick={() => window.open(`https://m.me/?link=${shareLink}`, '_blank')}
                      >
                        <i className="fa-brands fa-facebook-messenger me-3"></i> Messenger
                      </Button>
                      <Button
                        type="button"
                        className="exp-button"
                        onClick={() =>
                          window.open(
                            `https://www.facebook.com/sharer/sharer.php?u=${shareLink}`,
                            '_blank'
                          )
                        }
                      >
                        <i className="fa-brands fa-facebook me-3"></i> Facebook
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Dialog>
        <Footer />
      </ContentLayout>
    </>
  );
};
